/**
 * Carlino — hoppa automatiskt till en storlek som går att köpa, och håll
 * väntelistan i takt med den valda varianten.
 *
 * Del 1, storleksvalet. Produkterna har två alternativ, Color och Size. Byter
 * kunden färg behåller temat den storlek som redan var vald, och den
 * kombinationen kan vara slutsåld. Resultatet blir en produktsida med "Sold out"
 * i köpknappen trots att andra storlekar finns kvar i den färgen. Vi lyssnar på
 * temats egen variant:change och väljer första valbara storlek i samma grupp.
 *
 * Del 2, väntelistan. Prestige renderar om produktsidan partiellt vid varje
 * variantbyte, men för köpknappsblocket byter det bara ut själva
 * <buy-buttons>-elementet. Vårt <notify-me> ligger utanför det, som syskon till
 * <product-form>, och rörs därför aldrig. Följden är att väntelistan ligger kvar
 * när kunden byter till en säljbar storlek, och aldrig dyker upp när kunden
 * byter till en slutsåld. Serverns färska HTML följer med i
 * event.detail.htmlFragment, så vi läser <notify-me> därifrån och synkar.
 *
 * Notera att product:rerender dispatchas utan bubbles. Den måste därför fångas i
 * capture-fasen; en vanlig lyssnare på document fyrar aldrig.
 */
(function () {
  'use strict';

  // Skyddsnät mot en oändlig loop om temat och den här filen skulle dra åt
  // olika håll. Räknaren ligger här och inte på elementet, eftersom temat
  // byter ut hela variant-picker-elementet vid varje omrendering.
  var MAX_ATTEMPTS = 5;
  var attempts = 0;

  var BUY_BUTTONS_BLOCK = '[data-block-type="buy-buttons"]';

  function labelFor(input) {
    var next = input.nextElementSibling;

    return next && next.tagName === 'LABEL' ? next : null;
  }

  function isSoldOut(input) {
    var label = labelFor(input);

    return !!label && label.classList.contains('is-disabled');
  }

  function fixPicker(picker) {
    var inputs = Array.prototype.slice.call(
      picker.querySelectorAll('input[data-option-position]')
    );

    var soldOutSelection = inputs.filter(function (input) {
      return input.checked && isSoldOut(input);
    })[0];

    if (!soldOutSelection) {
      attempts = 0;
      return;
    }

    if (attempts >= MAX_ATTEMPTS) {
      return;
    }

    var position = soldOutSelection.dataset.optionPosition;

    var replacement = inputs.filter(function (input) {
      return input.dataset.optionPosition === position && !isSoldOut(input);
    })[0];

    if (!replacement) {
      return;
    }

    attempts += 1;
    replacement.checked = true;
    replacement.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fixAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('variant-picker'),
      fixPicker
    );
  }

  // Temat byter ut markupen efter varje variantbyte, så kontrollen måste köras
  // efter att den nya DOM:en är på plats.
  function fixAfterRender() {
    requestAnimationFrame(function () {
      requestAnimationFrame(fixAll);
    });
  }

  /**
   * Ta väntelistan ur serverns svar och lägg den där temat inte gör det själv.
   * Fragmentet klonas, eftersom temat plockar ut <buy-buttons> ur samma fragment
   * efter oss och inte ska få noder bortflyttade under fötterna.
   *
   * Sidan har två buy-buttons-block med samma data-block-id: ett i produktinfon
   * och ett i quick-buy-modalen. De hör till olika formulär, så vi utgår från det
   * formulär eventet kom från och rör bara block inom dess egen scope. Scopes
   * utan allow-partial-rerender byter temat ut i sin helhet och ska lämnas ifred.
   */
  function syncNotifyMe(form, fragment) {
    // OBS: form.id går inte att använda. Ett formulär exponerar sina fält som
    // egenskaper, och produktformuläret har ett <input name="id">, som skuggar
    // elementets eget id. form.id är alltså inputen, inte en sträng. Temat råkar
    // ut för samma sak och skriver därför form.id.value på sitt håll.
    var formId = form && form.getAttribute ? form.getAttribute('id') : null;

    if (!formId) {
      return;
    }

    var scopes = document.querySelectorAll(
      'product-rerender[observe-form="' + formId + '"][allow-partial-rerender]'
    );

    Array.prototype.forEach.call(scopes, function (scope) {
      // Samma id finns i fragmentet, så motsvarande block letas upp där inne och
      // inte i hela svaret. Annars kan quick-buy-modalens block matcha först.
      var incomingScope =
        (scope.id && fragment.querySelector('#' + scope.id)) || fragment;

      Array.prototype.forEach.call(
        scope.querySelectorAll(BUY_BUTTONS_BLOCK),
        function (currentBlock) {
          var blockId = currentBlock.getAttribute('data-block-id');

          if (!blockId) {
            return;
          }

          var incomingBlock = incomingScope.querySelector(
            BUY_BUTTONS_BLOCK + '[data-block-id="' + blockId + '"]'
          );

          if (!incomingBlock) {
            return;
          }

          var incoming = incomingBlock.querySelector('notify-me');
          var current = currentBlock.querySelector('notify-me');

          if (incoming && current) {
            current.replaceWith(incoming.cloneNode(true));
          } else if (incoming) {
            currentBlock.appendChild(incoming.cloneNode(true));
          } else if (current) {
            current.remove();
          }
        }
      );
    });
  }

  function onRerender(event) {
    var detail = event.detail;

    // Vid produktbyte ersätter temat hela blocket självt, inklusive väntelistan.
    if (!detail || !detail.htmlFragment || detail.productChange) {
      return;
    }

    syncNotifyMe(event.target, detail.htmlFragment);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixAll);
  } else {
    fixAll();
  }

  document.addEventListener('variant:change', fixAfterRender);
  document.addEventListener('product:rerender', onRerender, true);
})();